import { render, staticRenderFns } from "./CallUpdateIssues.vue?vue&type=template&id=4bc3449e"
import script from "./CallUpdateIssues.vue?vue&type=script&lang=js"
export * from "./CallUpdateIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports